import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { MicIcon } from "../../Assets/svgs/micIcon";
import { ConfirmModel } from "../../Model/ConfirmModel";
import ImportPhoneNumberModal from "../../Model/ImportPhoneNumberModal";
import { setUnsavedChanges } from "../../Redux/Slice/Common/SelectedTabSlice";
import { getPhoneNumbers } from "../../Redux/Slice/PhoneNumbers/GetPhoneNumberListSlice";

export const PhoneListSidebar = ({
  changeSelection,
  showSuccessMessage,
  selectedPhoneNumber,
  getPhoneNumberData,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const hasUnsavedChanges = useSelector(
    (state) => state.hasUnsavedChanges.hasUnsavedChanges
  );
  const { phoneNoListData } = useSelector((state) => state?.phoneNoList);
  const [showWarning, setWarning] = useState(false);
  const [editSelection, setEditSelection] = useState();
  const [showEditWarning, setEditWarning] = useState(false);
  const [importPhoneNumber, setImportPhoneNumber] = useState(false);

  const onAddConfirm = () => {
    setWarning(false);
    setImportPhoneNumber(true);
  };

  const onEditConfirm = () => {
    setEditWarning(false);
    dispatch(setUnsavedChanges(false));
    changeSelection(editSelection);
  };
  return (
    <div className="createAssistantMain__col h_100">
      {showWarning ? (
        <ConfirmModel
          onAccept={onAddConfirm}
          onReject={() => {
            setWarning(false);
          }}
          title="Import PhoneNumber!"
          message="Changes made will not be saved. Are you sure you wish to leave the page?"
        />
      ) : (
        ""
      )}
      {showEditWarning ? (
        <ConfirmModel
          onAccept={onEditConfirm}
          onReject={() => {
            setEditWarning(false);
          }}
          title="Edit PhoneNumber!"
          message="Changes made will not be saved. Are you sure you wish to leave the page?"
        />
      ) : (
        ""
      )}
      {importPhoneNumber ? (
        <ImportPhoneNumberModal
          closePopup={() => setImportPhoneNumber(false)}
          onSuccess={() => {
            setImportPhoneNumber(false);
            showSuccessMessage("Phone number imported successfully!");
            getPhoneNumberData();
          }}
        />
      ) : (
        ""
      )}
      <div className="createAssistantMain__card h_100">
        <div className="btn__group btn__group--directionColumn">
          <button
            className="btn btn__primary btn__outlined btn--full"
            onClick={() => setWarning(true)}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.00008 1.16699V12.8337M1.16675 7.00033H12.8334"
                stroke="#8b58f1"
                stroke-width="1.67"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Import Number
          </button>
          {/* {location?.state?.from != "edit" ? (
            <button className="btn btn--fontDeskVoicebot btn__primary btn--full">
              {selected.name}
              <span className="info">
                {selected?.voice?.voiceId ? selected?.voice?.voiceId : ""}
                <MicIcon />
              </span>
            </button>
          ) : (
            ""
          )} */}
          {phoneNoListData && phoneNoListData?.data
            ? phoneNoListData?.data.map((phoneNumber) => {
                return (
                  <button
                    className={
                      selectedPhoneNumber?.id === phoneNumber.id
                        ? "btn btn--fontDeskVoicebot btn__primary btn--full"
                        : "btn btn--fontDeskVoicebot btn__white btn--full"
                    }
                    onClick={() => {
                      // if (!selectedPhoneNumber?.id === phoneNumber.id) {
                      if (hasUnsavedChanges) {
                        setEditSelection(phoneNumber);
                        setEditWarning(true);
                      } else {
                        changeSelection(phoneNumber);
                      }
                      // }
                    }}
                  >
                    {phoneNumber?.number}
                    <span className="info" style={{width: "100%"}}>
                      {phoneNumber?.assistantName
                        ? phoneNumber?.assistantName
                        : ""}
                      <MicIcon />
                    </span>
                   {phoneNumber?.label? <span className="info">
                      {phoneNumber?.label}
                    </span> : null}
                  </button>
                );
              })
            : ""}
        </div>
      </div>
    </div>
  );
};
